import { FC, PropsWithChildren } from 'react'

import {
  DefaultPermissionsFallback,
  UserPermissionWrapper,
} from '@new/__global/components/UserPermissionWrapper'

import { STAY_INBOX_PRIVILEGES } from '../../useStayInboxPermission'

/**
 * Renders its children for users holding STAY_INBOX_READ or STAY_INBOX_WRITE and the standard
 * "no privileges" message for everyone else, e.g. when a link is opened directly.
 */
export const StayInboxPermissionWrapper: FC<PropsWithChildren> = ({ children }) => (
  <UserPermissionWrapper
    privilegeName={STAY_INBOX_PRIVILEGES}
    quantifier="some"
    fallbackMessage={<DefaultPermissionsFallback />}
  >
    {children}
  </UserPermissionWrapper>
)
